import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'safeNumber', pure: true })
export class SafeNumberPipe implements PipeTransform {
  transform(value: any, digits: string = '1.2-2'): string {
    if (value === null || value === undefined || value === '') return '';
    const num = Number(value);
    if (isNaN(num) || num < 0) return '';
    return num.toLocaleString('en-US', {
      minimumFractionDigits: Number(digits.split('.')[1]?.split('-')[0] ?? 2),
      maximumFractionDigits: Number(digits.split('-')[1] ?? 2),
    });
  }
}
